export default [
  {
    path: 'printing/qrcode',
    name: 'PrintingQrcode',
    component: () => import('@/views/Printing/Qrcode.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'printing-qrcode',
      template: 'printing',
    },
  },
  {
    path: 'qrcodes',
    name: 'qrcodes',
    component: () => import('@/views/Qrcode/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-qrcode',
      template: 'auth',
    },
  },
  {
    path: 'qrcode/:id',
    name: 'qrcodeLinkPage',
    component: () => import('@/views/Qrcode/LinkPage.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-qrcode',
      template: 'printing',
    },
  },
  {
    path: 'qrcode-content/:id',
    name: 'qrcodeContent',
    component: () => import('@/views/Qrcode/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-qrcode',
      template: 'auth',
    },
  },
  {
    path: 'qrcode-update/:id',
    name: 'qrcodeUpdate',
    component: () => import('@/views/Qrcode/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-qrcode',
      template: 'auth',
    },
  },
  {
    path: 'qrcode-create',
    name: 'qrcodeCreate',
    component: () => import('@/views/Qrcode/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-qrcode',
      template: 'auth',
    },
  },
  {
    path: 'print-qrcode',
    name: 'printQrcode',
    component: () => import('@/views/Printing/Qrcode.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'printing-qrcode',
      template: 'printing',
    },
  },
];
